module.exports = __webpack_public_path__ + "img/studio_center.d2f77685.jpg";